module.exports = __webpack_public_path__ + "img/icon-lottery-active.70c824a.webp";